import { createSlice } from "@reduxjs/toolkit";

export const setActiveTenantId = (activeTenantId) => {
  return {
    type: activeTenantIdSet.type,
    payload: {
      activeTenantId,
    },
  };
};

//
//Store Slice Creator
//

const slice = createSlice({
  name: "tenantReducer",
  initialState: {},
  reducers: {
    activeTenantIdSet: (tenants, action) => {
      tenants.activeTenantId = action.payload.activeTenantId;
    },
  },
});

export const { activeTenantIdSet } = slice.actions;

export default slice.reducer;
